

































































import { namespace } from 'vuex-class';
import { Vue, Component, Prop } from 'vue-property-decorator';

import Modal from '@/shared/components/Modal/Modal.vue';
import RadioBox from '@/shared/components/RadioBox/RadioBox.vue';
import EarlyRenewal from '@/shared/components/EarlyRenewal/EarlyRenewal.vue';
import ScreenSizeVisibility from '@/shared/components/ScreenSizeVisibility/ScreenSizeVisibility.vue';
import ReCAPTCHABranding from '@/shared/components/ReCAPTCHABranding/ReCAPTCHABranding.vue';

import BankSlipContent from './BankSlipContent.vue';
import PaymentActions from '../../../PaymentActions/PaymentActions.vue';
import Koin from './components/Koin/Koin.vue';

import { EPaymentMethodTypes, EPaymentMethod } from '@/helpers/enums';

import { Payment } from '@/classes/Checkout/Payment';
import { EBankSlipInstallmentSteps } from '@/shared/enums/EBankSlipInstallmentSteps';

const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    Modal,
    RadioBox,
    EarlyRenewal,
    PaymentActions,
    BankSlipContent,
    ScreenSizeVisibility,
    ReCAPTCHABranding,
    Koin,
  },
})
export default class BankSlip extends Vue {
  @Prop()
  private readonly type?: EPaymentMethodTypes;

  @Prop()
  private readonly active?: boolean;

  @Prop()
  private readonly isUpsell!: boolean;

  @Prop()
  private readonly validatePaymentType!: Function;

  @CheckoutModule.Getter('selectedOfferPayment')
  private readonly payment!: Payment;

  @CheckoutModule.Getter
  private readonly isKoinActivated!: boolean;

  @CheckoutModule.Getter
  private readonly bankSlipStep!: string;

  @CheckoutModule.Getter('isRenewal')
  private isRenewal: boolean;

  @CheckoutModule.Getter
  private selectedOfferPaymentStructure!: any;

  @CheckoutModule.Getter
  private getOfferPaymentConditionByMethodCode!: any;

  @CheckoutModule.State
  private readonly modalPayment!: boolean;

  @CheckoutModule.Mutation
  private readonly toggleModalPayment!: Function;

  private get isMobile () {
    return this.$vuetify.breakpoint.smAndDown;
  }

  private get wrapper () {
    return this.isMobile
      ? 'Modal'
      : 'div';
  }

  private get bankslip () {
    return this.payment.getPaymentMethod(EPaymentMethod.bankSlip);
  }

  private get bankSlipInstallmentsStep() {
    return this.bankSlipStep !== 'initial';
  }

  private get paymentTypeSelected () {
    return this.payment.selectedPaymentType;
  }

  private get paymentTypes () {
    return EPaymentMethodTypes;
  }

  private get wrapperTitle(): string {
    return this.isEmpiricusGift ? 'Seja bem-vindo à Empiricus' :
      this.bankSlipInstallmentsStep ? 'Boleto parcelado': 'Boleto';
  }

  private get isEmpiricusGift() {
    return this.$route.query.g === '1';
  }

  private prepareBankSlipInstallments(payload: any) {
    this.$emit('prepareBankSlipInstallments', payload);
  }

  private get paymentCondition() {
    return this.getOfferPaymentConditionByMethodCode(this.bankslip.method).payment_conditions;
  }

  private get paymentConditionBankSlip() {
    return this.paymentCondition && this.paymentCondition.find((value: any) => value.payment_method_code === this.bankslip.method);
  }

  private get showInstallment() {
    return this.paymentConditionBankSlip && this.paymentConditionBankSlip.min_installments_price > 99 && this.paymentConditionBankSlip.max_installments_number > 1;
  }
}
